import axios from 'axios';

const client = axios.create({
  baseURL: window.ENV.BASE_API_URL
});

export default client; 